export default () => ({
  initialized: false,
  init() {
    if (this.initialized) return;
    this.initialized = true;

    const prodFrequencyOptions = document.querySelectorAll('.page-hero-product-offers .product-frequency-option');
    const prodATCButtons = document.querySelectorAll(".page-hero-product-offers .add-to-cart");

    const mainProductPrice = document.querySelector(".page-hero-product-offers .product-pricing .product-price");
    const mainProductComparePrice = document.querySelector(".page-hero-product-offers .product-pricing .product-compare-price");


    function updateOptionState(otherElements, updateElement, state) {
      //unselect all other buttons
      for (let j = 0; j < otherElements.length; j++) {
        otherElements[j].classList.remove(state);
      }
      //mark as selected
      if (updateElement) updateElement.classList.add(state);
    }


    function updateCTAState(otherElements, updateElement, state) {
      //unselect all other buttons
      for (let j = 0; j < otherElements.length; j++) {
        otherElements[j].classList.add(state);
      }
      //mark as selected
      if (updateElement) updateElement.classList.remove(state);
    }

    for(let i = 0; i < prodFrequencyOptions.length; i++) {
        prodFrequencyOptions[i].addEventListener("click", function() {
            updateOptionState(prodFrequencyOptions, this, "selected");
            updateCTAState(prodATCButtons, prodATCButtons[i], "hidden");

            const comparePrice = this.getAttribute("data-compare-price");

            mainProductPrice.innerText = this.getAttribute("data-price");
            if(comparePrice) {
              mainProductComparePrice.innerText = comparePrice;
               mainProductComparePrice.style.display = "block";
            }
            else
              mainProductComparePrice.style.display = "none";
        });
    }


  }
});
